import { render, staticRenderFns } from "./index.vue?vue&type=template&id=637a1cfb&scoped=true&lang=html&"
import script from "./mergeSpreadStoreList.js?vue&type=script&lang=js&"
export * from "./mergeSpreadStoreList.js?vue&type=script&lang=js&"
import style0 from "./mergeSpreadStoreList.styl?vue&type=style&index=0&id=637a1cfb&lang=stylus&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637a1cfb",
  null
  
)

export default component.exports